/*
 * @Descripttion:
 * @Author: lqzh
 * @Date: 2020-02-28 16:31:28
 * @LastEditTime: 2026-05-19 09:14:05
 */
const { axios } = window;

if ('ontouchstart' in document) {
    document.body.addEventListener('touchstart', showMap, true);
    document.body.addEventListener('touchend', hideMap, true);
} else {
    document.body.addEventListener('mouseup', hideMap, true);
    document.body.addEventListener('mousedown', showMap, true);
}
document.body.addEventListener('contextmenu', e => {
    e.preventDefault();
});

axios.get('//api.zhuzhou.city/fun/people2/daily/json').then(res => {
    if (res.data.statusCode != 200) throw new Error(res.data.msg);
    document.querySelector('#ajaxDes').textContent =
        res.data.result.title + '...';
    document.querySelector('.top').dataset.src = res.data.result.link;
});

let todayPic = `//api.zhuzhou.city/fun/people2/daily/pic?${new Date().toLocaleDateString().replace(/\//g, '')}`;

const imgElm = document.querySelector('.cover');

imgElm.onerror = () => {
    imgElm.onerror = null;
    const fullback = './img/404.jpg';
    imgElm.setAttribute('src', fullback);
    document.querySelector('.slogan').style['background-image'] =
        `url(${fullback})`;
};

imgElm.setAttribute('src', todayPic);
document.querySelector('.slogan').style['background-image'] =
    `url(${todayPic})`;

let timer = 0;
function showMap(event) {
    clearTimeout(timer);
    timer = setTimeout(() => {
        event.stopPropagation();
        event.preventDefault();
        document.body.classList.add('showMap');
        console.log('down', event.type);
    }, 500);
}
function hideMap(event) {
    clearTimeout(timer);
    document.body.classList.remove('showMap');
    console.log('up', event.type);
}

function openSite(type) {
    switch (type) {
        case 'p2':
            window.open(document.querySelector('.top').dataset.src);
            break;
        case 'bike':
            window.open('//bike.zhuzhou.city');
            break;
        case 'parking':
            window.open('//parking.zhuzhou.city');
            break;
        case 'bus':
            window.open('/bus/');
            break;
        case 'wc':
            window.open('//wc.zhuzhou.city');
            break;
    }
}
window.openSite = openSite;
